import { OrderVoucher } from '@/screens/OrdersPage/ui';

export default OrderVoucher;
